export enum ProcessType {
  GLB_XKT = 'glb-xkt',
  IFC_XKT = 'ifc-xkt',
  STEP_GLB = 'step-glb',
  STEP_XKT = 'step-xkt',
  ZIP_EXTRACT = 'zip-extract',
  CALCULATE_HASH = 'calculate-hash',
  GENERATE_CSV = 'generate-csv',
  IFC_IDS_VALIDATE = 'ifc-ids-validate',
  IFC_MODEL_CHECK = 'ifc-model-check',
  CONVERT_METADATA = 'convert-metadata',
  RVT_XKT = 'rvt-xkt',
  RFA_XKT = 'rfa-xkt',
  NWD_XKT = 'nwd-xkt',
  NWC_XKT = 'nwc-xkt',
  POINTCLOUD_POTREE = 'pointcloud-potree',
}
